import api from '../../services/api';
import { OPERATOR_REQUEST_CONFIG, warehousePath } from '../operator/operatorApi';

/**
 * The tray of a warehouse: what the operator has on (`mine`), what comes
 * `next`, and the rest in order (`open`, up to `limit`), of the types asked
 * for whose flow is open to them. `counts` sizes every type, and `queues` is
 * the same as `me.warehouses[].queues`.
 *
 * @param {number|string} warehouseId
 * @param {{types: string[], limit: number}} params
 */
export const getTasksRequest = (warehouseId, { types, limit }) =>
  api.get(warehousePath(warehouseId, 'tasks/'), {
    ...OPERATOR_REQUEST_CONFIG,
    params: { types: types.join(','), limit },
  });
